module.exports = __webpack_public_path__ + "media/images/icon_q-070d553126d69ec797efd0e717e4aec4.png";